<template>
  <div class="mpTitle">
    <h3 class="mpTitle_title">{{ title }}</h3>
    <h4 class="mpTitle_sub">{{ subTitle }}</h4>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="less" scoped>
.mpTitle {
  text-align: right;
  .mpTitle_title {
    padding: 10px 0;
    color: black;
  }
  .mpTitle_sub {
    color: #17233d;
    padding-bottom: 5px;
  }
}
</style>
